import React from 'react';
import './LegalPages.css';

const Refund = () => {
  return (
    <div className="legal-page">
      <section className="legal-header">
        <div className="legal-header-content">
          <h1>Refund Policy</h1>
          <p className="subtitle">DocuAIHub Refund Policy</p>
          <p className="description">
            Your right to cancel purchases within 14 days under EU Directive 2011/83/EU.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="content-wrapper">
          <aside className="table-of-contents">
            <h3>Table of Contents</h3>
            <ul>
              <li><a href="#eu-directive">EU Directive Rights</a></li>
              <li><a href="#cancellation-period">14-Day Cooling-Off Period</a></li>
              <li><a href="#refund-process">Refund Process</a></li>
              <li><a href="#exceptions">Exceptions</a></li>
            </ul>
          </aside>

          <main className="main-content">
            <section id="eu-directive" className="content-section">
              <h2>Refund Policy</h2>
              <p>
                According to EU Directive 2011/83/EU, we provide consumers in the European Union 
                with the right to cancel their purchase within 14 days for any reason.
              </p>
              <p>
                This refund policy applies to all subscription purchases made through DocuAIHub. 
                We are committed to customer satisfaction and will process valid refund requests 
                promptly.
              </p>
            </section>

            <section id="cancellation-period" className="content-section">
              <h2>14-Day Cooling-Off Period</h2>
              <p>
                The 14-day "cooling-off" period begins from the date you subscribe to our service. 
                During this period, you have the right to cancel your subscription and receive a 
                full refund without providing any reason.
              </p>
              <p>
                <strong>How to Exercise Your Right:</strong>
              </p>
              <ul>
                <li>Send an email to <a href="mailto:help@docuaihub.com">help@docuaihub.com</a> with your cancellation request</li>
                <li>Include your account email address and subscription details</li>
                <li>Clearly state your intention to cancel and request a refund</li>
                <li>No explanation or justification is required</li>
              </ul>
              <p>
                <strong>Important Note:</strong> By using the Service after purchase, you acknowledge 
                that the service performance has begun. If you use the Service extensively during the 
                14-day period, we may deduct a proportional amount for services already rendered.
              </p>
            </section>

            <section id="refund-process" className="content-section">
              <h2>Refund Process</h2>
              <p>
                Once we receive your refund request, we will process it within 3-5 business days. 
                The refund will be issued to the original payment method used for the purchase.
              </p>
              <p><strong>Refund Timeline:</strong></p>
              <ul>
                <li>Request received and verified: 1-2 business days</li>
                <li>Refund processed: 3-5 business days</li>
                <li>Funds appear in your account: 5-10 business days (depending on your bank)</li>
              </ul>
              <p>
                You will receive an email confirmation once your refund has been processed. If you 
                do not see the refund in your account after 10 business days, please contact your 
                bank or payment provider.
              </p>
            </section>

            <section id="exceptions" className="content-section">
              <h2>Exceptions and Special Cases</h2>
              <p><strong>Outside the 14-Day Period:</strong></p>
              <p>
                Refund requests submitted after the 14-day cooling-off period will be evaluated on 
                a case-by-case basis. We may offer refunds for:
              </p>
              <ul>
                <li>Technical issues that prevented you from using the Service</li>
                <li>Billing errors or duplicate charges</li>
                <li>Service outages or significant performance issues</li>
              </ul>
              <p><strong>No Refunds For:</strong></p>
              <ul>
                <li>Subscriptions where the full billing period has been used</li>
                <li>Accounts suspended or terminated due to Terms of Service violations</li>
                <li>Change of mind after the 14-day period (unless exceptional circumstances)</li>
                <li>Free trial periods (no charge, no refund applicable)</li>
              </ul>
            </section>

            <section className="content-section">
              <h2>Chargebacks</h2>
              <p>
                We kindly request that you contact us directly before initiating a chargeback with 
                your payment provider. We are committed to resolving any issues and will work with 
                you to find a satisfactory solution.
              </p>
              <p>
                Initiating a chargeback without first contacting us may result in account suspension 
                and may affect your ability to use our services in the future.
              </p>
            </section>

            <section className="content-section">
              <h2>Contact Us for Refunds</h2>
              <p>
                To request a refund or if you have questions about our refund policy:
              </p>
              <ul>
                <li><strong>Email:</strong> <a href="mailto:help@docuaihub.com">help@docuaihub.com</a></li>
                <li><strong>Phone:</strong> +35777788373</li>
                <li><strong>Address:</strong> 1 Maiou 3, 2610 Agios Epifanios Oreinis, Cyprus</li>
              </ul>
              <p>
                Our customer support team is available Monday through Friday, 9:00 AM to 6:00 PM CET.
              </p>
            </section>

            <section className="content-section">
              <h2>EU Consumer Rights Information</h2>
              <p>
                This refund policy complies with EU Consumer Rights Directive 2011/83/EU. As an EU 
                consumer, you have specific rights when purchasing digital services online. For more 
                information about your consumer rights, visit the European Commission's consumer 
                rights portal.
              </p>
            </section>

            <section className="content-section">
              <p className="last-updated">Last Updated: February 2026</p>
            </section>
          </main>
        </div>
      </section>
    </div>
  );
};

export default Refund;
